import React from 'react'

import { useAuth } from '@shared/hooks/auth'

import { Centered, Column, Content, Row } from '@shared/components/Layout'
import { Info, ModuleSelect, Title } from './styles'
import { useHistory } from 'react-router-dom'
import { getHomePage } from '@shared/layouts/Partials/Navigation/menus'
import themes from '@config/themes'

const Modules = () => {
  const { unit } = useAuth()

  const history = useHistory()

  const [isLoading, setIsLoading] = React.useState(true)

  React.useEffect(
    function redirectIfUserHasOnlyOneModule () {
      if (unit?.modules?.length === 1) {
        history.push(
          getHomePage(unit?.modules.find(Boolean))
        )
      } else {
        setIsLoading(false)
      }
    }, [history, unit]
  )

  return (
    <Centered>
      <Content isLoading={isLoading}>
        <Title>Qual módulo você quer acessar?</Title>
        <Info>
          <Row $justifyCenter>
            {unit.modules?.map((module) => (
              <Column md={6} xl={4} key={module.name}>
                <ModuleSelect to={getHomePage(module)} style={{ background: themes[module.name].primary }}>
                  <img src={module.meta?.logo} alt="" style={styles.logo} />
                </ModuleSelect>
              </Column>
            ))}
          </Row>
        </Info>
      </Content>
    </Centered>
  )
}

const styles = {
  logo: { width: '100%', maxWidth: '260px' }
}

export default Modules
